import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export const defaultState = {
	avtaler: [],
	recommendation: null,
	selection: null,
	tilbudId: null,
	hasSlKundeSamtykke: false,
	hasSlInformasjonSamtykke: false,
	samtykkeEpost: "",
};

export default function slReducer(state = defaultState, action: Action) {
	switch (action.type) {
		case actions.FIND_SL_AVTALER_RESPONSE:
			return { ...state, ...action.data };
		case actions.SET_SLKUNDESAMTYKKE_RESPONSE:
			return {
				...state,
				hasSlKundeSamtykke: action.data,
			};
		case actions.SET_SLINFORMASJONSAMTYKKE_RESPONSE:
			return {
				...state,
				hasSlInformasjonSamtykke: action.data,
			};
		case actions.SET_KUNDE_SAMTYKKE_EPOST_RESPONSE:
			return {
				...state,
				samtykkeEpost: action.data,
			};
		default:
			return state;
	}
}
